import React from "react";
import PropTypes from "prop-types";
import { Grid, Container, Box } from "@mui/material";
import "@fortawesome/fontawesome-free/css/all.css";
import styles from "./index.module.scss";

function Template({ data }) {
  const {
    title,
    image,
    cta1_label: cta1Label,
    cta1_link: cta1Link,
    cta2_label: cta2Label,
    cta2_link: cta2Link,
  } = data;

  return (
    <div className={styles.wrapper}>
      <Container maxWidth="lg">
        <Grid container>
          <Grid item xs={12}>
            <h2 className={styles.title}>{title}</h2>
          </Grid>
          <Grid item xs={12}>
            <img
              className={styles.image}
              src={image.src.publicURL}
              alt={image.alt}
            />
          </Grid>
          <Box sx={{ justifyContent: "center" }} className={styles.ctaBox}>
            <a className={styles.cta} href={cta1Link}>
              {cta1Label}
            </a>
            <a className={styles.cta} href={cta2Link}>
              {cta2Label}
            </a>
          </Box>
        </Grid>
      </Container>
    </div>
  );
}

Template.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.shape({
        publicURL: PropTypes.string,
      }),
      alt: PropTypes.string,
    }),
    cta1_label: PropTypes.string,
    cta1_link: PropTypes.string,
    cta2_label: PropTypes.string,
    cta2_link: PropTypes.string,
  }).isRequired,
};

export default Template;
